<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label
                class="col-form-label ml-2 mr-2"
                style="min-width: 55px; display: block"
                >검색조건</label
              >
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CTabs :active-tab.sync="tab">
              <CTab title="실내부" active>
                <div class="p-2">
                  <CRow>
                    <CCol col="12" xl="8">
                      <CCard class="w-100 h-100">
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          실내부 생육환경 분석
                        </CCardHeader>
                        <CCardBody class="d-flex p-2 h-100">
                          <div
                            ref="inEnvChart"
                            style="width: 100%; height: 400px; margin: auto 0"
                            :class="
                              inEnv.data == null || inEnv.data.length === 0
                                ? 'd-none'
                                : ''
                            "
                          ></div>
                          <div
                            style="
                              width: 100%;
                              height: 400px;
                              display: flex;
                              justify-content: center;
                              flex-direction: column;
                              text-align: center;
                              font-weight: bold;
                              font-size: 150%;
                              color: #ff0d0d;
                            "
                            v-if="inEnv.data == null || inEnv.data.length === 0"
                          >
                            <div>
                              <i
                                class="fa fa-times-circle"
                                aria-hidden="true"
                              ></i>
                              데이터 없음
                            </div>
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                    <CCol col="12" xl="4" class="mt-4 mt-xl-0">
                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          일일 온실 환경 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #ffbb00"
                              >
                                <i class="fa fa-sun-o" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time font-weight-bold">
                                온도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  일일 분석 : 빅데이터 분석 모델을 기준으로 금일
                                  온실내 온도는
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true"
                                    >+11.28도
                                  </i>
                                  예측을 보이며,
                                </p>
                                <p>
                                  현재 분석 : 온실내 온도가
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절
                                  </i>
                                  하여 기존 제어방식을 유지합니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #0044ff"
                              >
                                <i class="fa fa-tint" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time font-weight-bold">
                                습도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  일일 분석 : 빅데이터 분석 모델을 기준으로 금일
                                  온실내 습도는
                                  <i class="label bg-color-red scc-rounded" aria-hidden="true"
                                    >-14.97%</i
                                  >
                                  예측을 보이며,
                                </p>
                                <p>
                                  현재 분석 : 습도가
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절
                                  </i>
                                  하여 기존 제어방식을 유지합니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #757575"
                              >
                                <i class="fa fa-leaf" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time font-weight-bold">
                                CO2
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >
                                  한 수준입니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>

                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          주간 생육 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #ffbb00"
                              >
                                <i class="fa fa-sun-o" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                <small>온도</small>
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  지난주 토마토의 생장이 표준모델과 비교했을 때
                                  줄기두께는 굵고 영양생장의 경향이 보입니다.
                                  그에따라 온실내 일일 평균 온도를 약
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true"
                                    >1도</i
                                  >
                                  정도 올리며, 특히 주간온도를
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true"
                                    >2도</i
                                  >
                                  높여 균형생장으로 유도하기를 추천드립니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>
                      <CRow>
                        <CCol lg="4">
                          <CButton color="danger" class="w-100"
                            >추천제어
                          </CButton>
                        </CCol>
                        <CCol lg="4">
                          <CButton color="success" class="w-100"
                            >자동제어
                          </CButton>
                        </CCol>
                        <CCol lg="4">
                          <CButton color="info" class="w-100">수동제어</CButton>
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="inEnv.data == null || inEnv.data.length === 0"
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="근권부">
                <div class="p-2">
                  <CRow>
                    <CCol col="12" xl="8">
                      <CCard class="w-100 h-100">
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          근권부 생육환경 분석
                        </CCardHeader>
                        <CCardBody class="d-flex p-2 h-100">
                          <div
                            ref="rootEnvChart"
                            style="width: 100%; height: 400px; margin: auto 0"
                            :class="
                              rootEnv.data == null || rootEnv.data.length === 0
                                ? 'd-none'
                                : ''
                            "
                          ></div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                    <CCol col="12" xl="4" class="mt-4 mt-xl-0">
                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          일일 토양 환경 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #ffbb00"
                              >
                                <i class="fa fa-sun-o" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                토양<br />온도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true"
                                    >3도</i
                                  >
                                  낮습니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #0044ff"
                              >
                                <i class="fa fa-tint" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                토양<br />습도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #757575"
                              >
                                <i class="fa fa-bolt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">토양<br />EC</div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #757575"
                              >
                                <i class="fab fa-product-hunt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">토양<br />PH</div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>

                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          주간 토양 환경 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #ffbb00"
                              >
                                <i class="fa fa-sun-o" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                토양<br />온도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true"
                                    >3도</i
                                  >
                                  낮습니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #0044ff"
                              >
                                <i class="fa fa-tint" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                토양<br />습도
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #757575"
                              >
                                <i class="fa fa-bolt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">토양<br />EC</div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div
                                class="scc-timeline-icon"
                                style="background-color: #757575"
                              >
                                <i class="fab fa-product-hunt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">토양<br />PH</div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i
                                    class="label bg-color-green-dark scc-rounded"
                                    >적절</i
                                  >한 수준입니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </div>
              </CTab>
              <CTab title="양액부">
                <div class="p-2">
                  <CRow>
                    <CCol col="12" xl="8">
                      <CCard class="w-100 h-100">
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          실내부 생육환경 분석
                        </CCardHeader>
                        <CCardBody class="d-flex p-2 h-100">
                          <div
                            ref="nutrientSolutionChart"
                            style="width: 100%; height: 400px"
                            :class="
                              nutrientSolution.data == null ||
                              nutrientSolution.data.length === 0
                                ? 'd-none'
                                : ''
                            "
                          ></div>
                          <div
                            style="
                              width: 100%;
                              height: 400px;
                              display: flex;
                              justify-content: center;
                              flex-direction: column;
                              text-align: center;
                              font-weight: bold;
                              font-size: 150%;
                              color: #ff0d0d;
                            "
                            v-if="
                              nutrientSolution.data == null ||
                              nutrientSolution.data.length === 0
                            "
                          >
                            <div>
                              <i
                                class="fa fa-times-circle"
                                aria-hidden="true"
                              ></i>
                              데이터 없음
                            </div>
                          </div>
                        </CCardBody>
                      </CCard>

                    </CCol>
                    <CCol col="12" xl="4" class="mt-4 mt-xl-0">
                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          일일 토양 환경 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div class="scc-timeline-icon" style="background-color: #757575;">
                                <i class="fa fa-bolt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                EC
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true">20%</i>부족한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div class="scc-timeline-icon" style="background-color: #28a745;">
                                <i class="fab fa-product-hunt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                PH
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-green-dark scc-rounded" aria-hidden="true">적절</i>한 수준입니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>

                      <CCard>
                        <CCardHeader
                          class="p-2 font-weight-bold"
                          style="line-height: 2"
                        >
                          주간 토양 환경 분석
                        </CCardHeader>
                        <CCardBody class="p-2 position-relative">
                          <ul class="scc-timeline-list">
                            <li>
                              <div class="scc-timeline-icon" style="background-color: #757575;">
                                <i class="fa fa-bolt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                EC
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-orange scc-rounded" aria-hidden="true">20%</i>부족한 수준입니다.
                                </p>
                              </div>
                            </li>
                            <li>
                              <div class="scc-timeline-icon" style="background-color: #28a745;">
                                <i class="fab fa-product-hunt" aria-hidden="true"></i>
                              </div>
                              <div class="scc-timeline-time">
                                PH
                              </div>
                              <div class="scc-timeline-content">
                                <p>
                                  표준 토마토 환경 모델에
                                  <i class="label bg-color-green-dark scc-rounded" aria-hidden="true">적절</i>한 수준입니다.
                                </p>
                              </div>
                            </li>
                          </ul>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </div>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import store from "@/store";
import core from "@/core";
import MixinsInFacility from "@/mixins/in-facility";
import SensorService from "@/services/sensor/sensor.service";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
  name: "EnvRecomm",
  components: { ExtEnvComponent },
  mixins: [MixinsInFacility()],
  data() {
    return {
      tab: 0,
      inEnv: {
        chart: null,
        data: null,
        getListFunction: SensorService.getInEnvList,
        refId: "inEnvChart",
        sensorList: store.state.app.constant.sensor.inEnvList,
      },
      rootEnv: {
        chart: null,
        data: null,
        getListFunction: SensorService.getRootEnvList,
        refId: "rootEnvChart",
        sensorList: store.state.app.constant.sensor.rootEnvList,
      },
      nutrientSolution: {
        chart: null,
        data: null,
        getListFunction: SensorService.getNutrientSolutionList,
        refId: "nutrientSolutionChart",
        sensorList: store.state.app.constant.sensor.nutrientSolutionList,
      },
    };
  },
  watch: {
    tab() {
      this.getSensorData();
    },
    inFacilityId(val) {
      console.log("changed inFacilityId");
      if (val != null) {
        this.getSensorData();
      }
    },
  },
  methods: {
    async getSensorData() {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId == null) {
        console.log("null");
        return null;
      }

      let sensorItem = null;
      if (this.tab === 0) {
        sensorItem = this.inEnv;
      } else if (this.tab === 1) {
        sensorItem = this.rootEnv;
      } else if (this.tab === 2) {
        sensorItem = this.nutrientSolution;
      } else {
        console.log("Unknown tab : ", this.tab);
        return;
      }
      console.log("sensorItem : ", sensorItem);
      if (sensorItem.chart == null) {
        this.createChart(sensorItem);
      }

      const startMoment = core.date.instance();
      const endMoment = core.date.instance().add(1, "days");
      const list = await sensorItem.getListFunction({
        inFacilityId: inFacilityId,
        sensingAtGreaterThanEqual: startMoment.format("YYYY-MM-DD"),
        sensingAtLessThan: endMoment.format("YYYY-MM-DD"),
      });
      list.forEach((sensor) => {
        sensor.date = core.date.instance(sensor.sensingAt).toDate();
      });
      console.log("list : ", list);
      sensorItem.data = list;
      sensorItem.chart.data = sensorItem.data;
    },
    createChart(sensorItem) {
      const $el = this.$refs[sensorItem.refId];
      const chart = core.amchart.createXYDateChart($el);

      const seriesList = [];
      const dateFieldName = "date";
      const toggleAllSeries = core.amchart.createLineSeries(
        chart,
        "void",
        dateFieldName,
        "Toggle All",
        "#3e3e3e",
      );
      toggleAllSeries.events.on("hidden", function () {
        seriesList.forEach((series) => {
          series.hide();
        });
      });
      toggleAllSeries.events.on("shown", function () {
        seriesList.forEach((series) => {
          series.show();
        });
      });

      let toggle = false;
      sensorItem.sensorList.forEach((sensor) => {
        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        const series = core.amchart.createLineSeries(
          chart,
          sensor.fieldName,
          dateFieldName,
          sensor.label,
          sensor.colorHex,
          sensor.unit,
        );
        series.yAxis = valueAxis;
        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = toggle;
        toggle = !toggle;
        seriesList.push(series);
      });

      const scrollbarX = new am4core.Scrollbar();
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;
      chart.data = [];
      sensorItem.chart = chart;
    },
  },
};
</script>
